import React, { lazy } from 'react';
import { motion } from 'framer-motion';
const IMAGES = [{
  src: 'https://cdn.magicpatterns.com/uploads/bajEVEwPxJCRYTDAUUgD8Y/cambia_el_libro_por_este_202606291431.jpg',
  alt: 'Hombre mostrando el libro Reset Metabólico en su living'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/1RNLgYQmaoeqYAnS5G9qRX/A_raw,_hyper-realistic_UGC_phone_202606291436.jpg',
  alt: 'Hombre tomando mate mostrando Reset Metabólico en el celular'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/rxrHGgLuWRs2GJenmmYPps/A_realistic_UGC-style_casual_photograph_202606291435.jpg',
  alt: 'Mujer en la oficina sosteniendo el libro Reset Metabólico'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/iNehrji87AQWojBvr4YXdn/A_candid,_hyper-realistic_UGC_mobile_202606291432.jpg',
  alt: 'Mujer feliz mostrando Reset Metabólico junto a un plato saludable'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/7i6eyeMq6D543yrRv9tKNS/A_candid,_hyper-realistic_UGC_mobile_202606291431.jpg',
  alt: 'Señora sonriente mostrando Reset Metabólico en la cocina'
}];
export function UgcMarquee() {
  // Duplicate the list so the loop is seamless
  const loop = [...IMAGES, ...IMAGES];
  return <section className="bg-white py-10 md:py-14 overflow-hidden" aria-label="Personas usando Reset Metabólico" data-id="element-224">
      <div className="text-center mb-8 px-4" data-id="element-225">
        <span className="text-blue-600 font-bold tracking-wider uppercase text-sm" data-id="element-226">
          Comunidad real
        </span>
        <h2 className="text-2xl md:text-3xl font-bold text-slate-900 mt-2" data-id="element-227">
          Miles de argentinos ya empezaron su Reset
        </h2>
      </div>

      <div className="relative" data-id="element-228">
        {/* Fade edges */}
        <div className="pointer-events-none absolute left-0 top-0 bottom-0 w-12 md:w-24 bg-gradient-to-r from-white to-transparent z-10" data-id="element-229" />
        <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-12 md:w-24 bg-gradient-to-l from-white to-transparent z-10" data-id="element-230" />

        <motion.div className="flex gap-4 md:gap-6 w-max" animate={{
        x: ['0%', '-50%']
      }} transition={{
        ease: 'linear',
        duration: 30,
        repeat: Infinity
      }} data-id="element-231">
          {loop.map((img, i) => <div key={i} className="shrink-0 w-40 sm:w-52 md:w-64 aspect-[3/4] rounded-2xl overflow-hidden shadow-lg border border-slate-100" data-id="element-232">
              <img src={img.src} alt={img.alt} loading="lazy" className="w-full h-full object-cover" data-id="element-233" />
            </div>)}
        </motion.div>
      </div>
    </section>;
}